import { createSlice } from "redux-starter-kit";

// Split into pending and active filters.
const initialState = { open: false };
const feedSideBar = createSlice({
    slice: "feedSidebar",
    initialState,
    reducers: {
        openSidebar(state) {
            // State can be modified directly when inside createSlice
            state.open = true;
        },
        closeSidebar(state) {
            state.open = false;
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = feedSideBar;
// Extract and export each action creator by name
export const { openSidebar, closeSidebar } = actions;
// Export the reducer, either as a default or named export
export default reducer;
